import { faBan, faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import {
  GSActionBar,
  GSButton,
  GSCircleImage,
  GSInfoGroup,
  GSItemList,
} from "golfstatus_react_components";
import React from "react";

import "./tournament-team-item.scss";
import { displayPlayerHandicap, displayTeamHandicap } from "../../../helpers/Handicaps";

const TournamentTeamItem = (props) => {
  const {
    header,
    headerName,
    team,
    tournament,
    messageClicked,
    verticalPlayers,
  } = props;

  //const defaultAvatar = "https://api.golfstatus.dev/images/user_round.png";

  const contactInfo = {
    sectionItems: [
      {
        type: "primary no-wrap full-width capitalize",
        value: `${team?.name ?? `${team?.contactName}`} ${displayTeamHandicap(team, tournament)}`,
      },
      { type: "secondary", value: team?.entryCode },
    ],
  };

  const noPlayerInfo = {
    sectionItems: [
      {
        type: "secondary no-wrap full-width capitalize",
        value: `No Players`,
      },
    ],
  };

  const playerInfo = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: (
          <GSItemList
            type={`${
              verticalPlayers ? "vertical" : "horizontal"
            } mobile-vertical large-gap`}
            items={team?.players}
            listItem={(player) => (
              <div className="player">
                <GSCircleImage size="large" url={player.avatar}></GSCircleImage>
                <div className="player-name">
                  {`${player.name} ${displayPlayerHandicap(player, tournament)}`}
                </div>
                <div className="player-tags">
                  {player.flag === "pro" && (
                    <GSButton type="secondary pill green" title="Pro" />
                  )}
                  {player.signupMessage && (
                    <GSButton
                      type="secondary"
                      buttonIcon={faCommentAlt}
                      onClick={(e) => {
                        messageClicked?.({ ...player, contactName: player.name });
                        e?.stopPropagation?.();
                      }}
                    ></GSButton>
                  )}
                </div>
              </div>
            )}
          />
        ),
      },
    ],
  };

  const teamInfo = {
    fit: "stretch",
    sections:
      team?.players?.length === 0
        ? [{ ...contactInfo }, { ...noPlayerInfo }]
        : [{ ...contactInfo }, { ...playerInfo }],
  };

  const registrationInfo = {
    sections: [],
  };

  if (team?.disqualified) {
    registrationInfo.sections.push({
      sectionItems: [
        {
          type: "primary full-width",
          value: (
            <GSButton
              type={`full-width pill secondary ${
                team?.disqualified ? "orange" : "transparent"
              }`}
              buttonIcon={faBan}
              title={
                team?.disqualified ? team?.disqualificationReason.replace?.("_", " ") : ""
              }
            ></GSButton>
          ),
        },
      ],
    });
  } else if (team?.mainLeaderboardScoreDetails?.totalScore) {
    registrationInfo.sections.push({
      fit: "end-justify",
      sectionItems: [
        {
          type: "primary",
          value: team?.mainLeaderboardScoreDetails?.totalScore,
        },
        {
          type: "secondary",
          value: team?.mainLeaderboardScoreDetails?.netTotal,
        },
      ],
    });
  }

  const getGroup = () => {
    let group = [{ ...teamInfo }, { ...registrationInfo }];
    return group;
  };

  return (
    <tournament-team-item class={header ? "header" : ""}>
      {header ? (
        <GSActionBar header={headerName}></GSActionBar>
      ) : (
        <GSInfoGroup
          listType="mobile-vertical"
          dataGroups={getGroup()}
        ></GSInfoGroup>
      )}
    </tournament-team-item>
  );
};

export default TournamentTeamItem;
